import React, { FC, useState, useCallback, useEffect } from 'react'
import { createStyles, makeStyles } from '@zn-material-ui'
import { getValidPass } from '@utils'
import fork from './img/fork.png'
import hide from './img/hide.png'
import show from './img/show.png'
import AppListDialog, { dataType } from './AppListDialog'

const useStyles = makeStyles(() =>
  createStyles({
    accountContainer: {
      display: 'flex',
      alignItems: 'flex-end',
      position: 'relative',
      height: 60,
      marginTop: 25,
    },
    textField: {
      width: '460px',
      marginTop: '25px',
      marginBottom: 0,
    },
    icon: {
      position: 'absolute',
      bottom: '10px',
      right: '75px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    }
  })
)
import TextField from '@components/TextField'

export type UnionLabelType = 'password' | 'username'
export type OnChangeType = (label: UnionLabelType, value: string) => void
import { transform } from '@utils/intl_lang'
interface IProps {
  usernameOrPwdError: boolean
  captchaError: boolean
  captchaUrl: string
  username: string
  password: string
  rememberPwd: boolean
  onChange: (label: string, value: string) => void
  onCaptchaImgLoad: () => void
  appListDialogVisible: boolean
  appList: dataType
  onClose: () => void
  onSelectApp: (appId: string) => () => void
  dialogTitle: string
  loginLoading: boolean
  isCancelLogin: boolean
  resetLogin: () => void
}

const NormalLoginFrom: FC<IProps> = ({
  rememberPwd,
  usernameOrPwdError,
  isCancelLogin,
  ...props
}) => {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [showPassword, setShowPassword] = useState(false)
  const classes = useStyles()

  const onChange = useCallback(
    (label: UnionLabelType) => (event: React.ChangeEvent<HTMLInputElement>) => {
      let value = event.target.value
      switch (label) {
      case 'username':
        setUsername(value)
        break
      case 'password':
        value = getValidPass(value)
        setPassword(value)
        break
      default:
      }
      props.onChange(label, value)
    },
    [username]
  )

  const onAccountChange = () => {
    setUsername('')
  }

  const togglePasswordShow = () => {
    setShowPassword(!showPassword)
  }

  useEffect(() => {
    if (rememberPwd) {
      setUsername(props.username)
      setPassword(props.password)
    }
  }, [])

  useEffect(() => {
    if (isCancelLogin) {
      props.onCaptchaImgLoad()
      props.resetLogin()
    }
  }, [isCancelLogin])

  return (
    <>
      <div className={classes.accountContainer}>
        <TextField
          id="standard-name"
          // '账户或密码错误' : '账户'
          label={
            usernameOrPwdError
              ? transform('Login_accout_pwd_error')
              : transform('Login_accout')
          }
          placeholder="请输入邮箱"
          className={classes.textField}
          value={username}
          onChange={onChange('username')}
          error={usernameOrPwdError}
        // onBlur={props.onUserNameBlur}
        />
        {username.length ? (
          <div
            className={classes.icon}
            onClick={onAccountChange}
          >
            <img style={{ width: '17.5px', height: '17.5px' }} src={fork} alt="" />
          </div>
        ) : null}
      </div>
      <div className={classes.accountContainer}>
        <TextField
          id="standard-password-input"
          // "密码"
          label={transform('Login_pwd')}
          placeholder="请输入密码"
          className={classes.textField}
          type={showPassword ? 'text' : 'password'}
          value={password}
          onChange={onChange('password')}
          error={usernameOrPwdError}
        />
        <div
          className={classes.icon}
          onClick={togglePasswordShow}
        >
          <img
            style={{ width: '17.5px', height: '17.5px' }}
            src={showPassword ? show : hide}
          />
        </div>
      </div>
      {props.appListDialogVisible && (
        <AppListDialog
          data={props.appList}
          title={props.dialogTitle}
          loading={props.loginLoading}
          handleClose={props.onClose}
          handleSelect={props.onSelectApp}
        />
      )}
    </>
  )
}

export default NormalLoginFrom
